<office-modal-container class="reasons-modal">
	<div header class="reasons-modal--header">
		<h1 class="modal-title">
			{{ 'SCHEDULE.REASONS.TITLE' | translate }}
		</h1>
		<button class="modal-close" (click)="close()">
			<office-icon name="close"></office-icon>
		</button>
	</div>
	<div body class="reasons-modal--body">
		<div class="session-details">
			<div>
				<p>
					<strong>{{ 'GENERAL.PATIENT' | translate }}: </strong>
					{{ userName }}
				</p>
				<p>
					<strong>{{ 'GENERAL.SESSION_DATE' | translate }}: </strong>
					{{ sessionDate }} - {{ sessionStartTime }}
				</p>
			</div>
			<div *ngIf="noShowClient" class="no-show">
				<input
					type="checkbox"
					name="no-show-client-checkbox"
					id="no-show-client-checkbox"
					(change)="toggleNoShowClient()"
					[(ngModel)]="noShowClientCheckbox"
				/>
				<label for="no-show-client-checkbox">{{ noShowClient.name }}</label>
			</div>
		</div>
		<div class="reasons-input-group">
			<ul #selectedReasonsList class="selected-reasons">
				<li *ngIf="selectedReasons.length === 0">
					{{ 'SCHEDULE.REASONS.NOT_SELECTED' | translate }}
				</li>
				<li
					*ngFor="let subarea of selectedReasons"
					class="subarea-pill selected"
					(click)="toggleReason(subarea)"
				>
					{{ subarea.name }}
					<office-icon
						*ngIf="isSelected(subarea)"
						name="close-circle"
						size="20"
						style="margin-left: 0.2rem"
					></office-icon>
				</li>
			</ul>
			<div
				[class.warning]="highlightInputError"
				[class.disabled]="noShowClientCheckbox"
			>
				<label for="search-reason-input">
					<office-icon name="search"></office-icon>
				</label>
				<input
					id="search-reason-input"
					type="text"
					[placeholder]="'SCHEDULE.REASONS.SELECT.PLACEHOLDER' | translate"
					(keyup)="searchReasons()"
					[(ngModel)]="searchTerm"
					[disabled]="noShowClientCheckbox"
				/>
			</div>
		</div>
		<div class="reasons-list">
			<ul class="main-areas">
				<li
					*ngFor="let area of mainAreas"
					class="main-area-item"
					(click)="setSelectedArea(area)"
					[class.selected]="selectedMainArea?.id === area.id"
				>
					{{ area.name }} ({{ area.children.length }})
					<office-icon name="chevron-down"></office-icon>
				</li>
			</ul>
			<ul *ngIf="reasonsList?.length > 0" class="sub-areas">
				<li
					*ngFor="let subarea of reasonsList"
					class="subarea-pill"
					[class.selected]="isSelected(subarea)"
					(click)="toggleReason(subarea)"
				>
					{{ subarea.name }}
					<office-icon
						*ngIf="isSelected(subarea)"
						name="close-circle"
						size="20"
						style="margin-left: 0.2rem"
					></office-icon>
				</li>
			</ul>
			<div
				*ngIf="!reasonsList?.length || noShowClientCheckbox"
				class="sub-areas"
			>
				<div *ngIf="noShowClientCheckbox">
					{{ 'SCHEDULE.REASONS.NO_SHOW' | translate }}
				</div>
				<div *ngIf="!noShowClientCheckbox && !searchTerm">
					{{ 'SCHEDULE.REASONS.SELECT.MSG' | translate }}
				</div>
				<div *ngIf="!noShowClientCheckbox && noReasonsFound">
					<p>
						<strong>{{
							'SCHEDULE.REASONS.NOT_FOUND.TITLE' | translate
						}}</strong>
					</p>
					{{ 'SCHEDULE.REASONS.NOT_FOUND.MSG' | translate }}
				</div>
			</div>
		</div>
	</div>
	<div footer class="reasons-modal--footer">
		<p [innerHTML]="'SCHEDULE.REASONS.DISCLOSURE' | translate"></p>
		<div *ngIf="!isLoading">
			<button class="cancel" (click)="cancel()">
				{{ 'OPERATIONS.CANCEL' | translate }}
			</button>
			<button
				class="save"
				[class.disabled]="selectedReasons.length === 0 && !noShowClientCheckbox"
				(click)="save()"
			>
				{{ 'OPERATIONS.SAVE' | translate }}
			</button>
		</div>
		<div *ngIf="isLoading">
			<freud-loader size="sm" [bgColor]="false"></freud-loader>
		</div>
	</div>
</office-modal-container>
